exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".caroussel{position:relative;overflow:hidden;min-height:60px;background:#f8f8f8}.caroussel-nav{position:absolute;margin-top:-30px;top:50%;left:10px;border:0;color:#fff;width:60px;height:60px;background:rgba(0,0,0,.6);font-size:18px;line-height:0;cursor:pointer}.caroussel-next{right:10px;left:auto}.caroussel-pagination{position:absolute;left:10px;right:10px;bottom:10px;text-align:center}.caroussel-pagination button{margin:0 5px;padding:0;display:inline-block;opacity:.8;border:0;background:transparent;color:#000;text-align:center;cursor:pointer}.caroussel-pagination button.active{color:#fff}", ""]);

// exports
